import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@ui/app-router';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@ui/primitives/dropdown-menu';
import { SidebarMenuAction } from '@ui/primitives/sidebar';
import { GitBranch, MoreHorizontal, RefreshCw, Tag, Tv2 } from 'lucide-react';
export function ApplicationContextMenu(param) {
    let { application, project, organization, onOpenChange } = param;
    return /*#__PURE__*/ _jsxs(DropdownMenu, {
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                asChild: true,
                children: /*#__PURE__*/ _jsxs(SidebarMenuAction, {
                    showOnHover: true,
                    "data-e2e": "LAYOUT_SIDEBAR__APPLICATION_CONTEXT_MENU_TRIGGER",
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                    },
                    className: "hover:bg-sidebar rounded-[4px] cursor-pointer",
                    children: [
                        /*#__PURE__*/ _jsx(MoreHorizontal, {
                            className: "h-4 w-4"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "sr-only",
                            children: "More options"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(DropdownMenuContent, {
                side: "right",
                align: "start",
                className: "bg-popover border border-border",
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        asChild: true,
                        className: "cursor-pointer hover:bg-sidebar gap-2 rounded-sm p-4 font-sans font-normal text-sm text-foreground",
                        children: /*#__PURE__*/ _jsxs(Link, {
                            to: "/org/$organization/$project/app/$application/devops/environment",
                            params: {
                                organization,
                                project,
                                application
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Tv2, {
                                    className: "h-4 w-4 text-muted-foreground"
                                }),
                                "Environments"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        asChild: true,
                        className: "cursor-pointer hover:bg-sidebar gap-2 rounded-sm p-4 font-sans font-normal text-sm text-foreground",
                        children: /*#__PURE__*/ _jsxs(Link, {
                            to: "/org/$organization/$project/app/$application/devops/tags",
                            params: {
                                organization,
                                project,
                                application
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Tag, {
                                    className: "h-4 w-4 text-muted-foreground"
                                }),
                                "Tags"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        asChild: true,
                        className: "cursor-pointer hover:bg-sidebar gap-2 rounded-sm p-4 font-sans font-normal text-sm text-foreground",
                        children: /*#__PURE__*/ _jsxs(Link, {
                            to: "/org/$organization/$project/app/$application/devops/redeployment",
                            params: {
                                organization,
                                project,
                                application
                            },
                            children: [
                                /*#__PURE__*/ _jsx(RefreshCw, {
                                    className: "h-4 w-4 text-muted-foreground"
                                }),
                                "Redeployment"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        asChild: true,
                        className: "cursor-pointer hover:bg-sidebar gap-2 rounded-sm p-4 font-sans font-normal text-sm text-foreground",
                        children: /*#__PURE__*/ _jsxs(Link, {
                            to: "/org/$organization/$project/app/$application/versions",
                            params: {
                                organization,
                                project,
                                application
                            },
                            children: [
                                /*#__PURE__*/ _jsx(GitBranch, {
                                    className: "h-4 w-4 text-muted-foreground"
                                }),
                                "Versions"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
